import { render, staticRenderFns } from "./BtnExcluirComissionamento.vue?vue&type=template&id=3c60f77c"
import script from "./BtnExcluirComissionamento.vue?vue&type=script&lang=js"
export * from "./BtnExcluirComissionamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports